import React from "react";
import "./settings.css";

export default function Settings({ setSettings }) {
    return (
      <div className="settings-container">
        <h3>Adjust Settings</h3>
        <div className="btn-group-vertical">
          <button onClick={() => setSettings("Geo Settings Applied")} className="btn btn-secondary">Geo Settings</button>
          <button onClick={() => setSettings("DDMMRS Mode Activated")} className="btn btn-secondary">DDMMRS</button>
          <button onClick={() => setSettings("DDMM Mode Activated")} className="btn btn-secondary">DDMM</button>
          <button onClick={() => setSettings("UTM Mode Activated")} className="btn btn-secondary">UTM</button>
        </div>
      </div>
    );
  }
  